export class Comment {
  id: number;
  userName: string;
  comment: string;
  proposalId: number;
  createdAt: Date;
  userId: number;
}
